import { documentTypeSchema, type DocumentType } from '@erp/shared';
import { newWorkPath } from '@/app/work-tabs/work-tab-context';

export type EntryStep = 'customer' | 'items' | 'review';

export function entryStepForField(fieldId: string): EntryStep {
  if (fieldId.startsWith('doc-item') || fieldId === 'document-items') return 'items';
  if (
    [
      'doc-header',
      'doc-footer',
      'doc-note',
      'document-texts',
      'document-notes',
      'document-portal',
      'document-attachments',
    ].includes(fieldId)
  )
    return 'review';
  return 'customer';
}

/** Reveal nested native disclosures before moving keyboard focus to an error. */
export function focusEntryField(id: string): void {
  const field = document.getElementById(id);
  for (let parent = field?.parentElement; parent; parent = parent.parentElement) {
    if (parent instanceof HTMLDetailsElement) parent.open = true;
  }
  field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  field?.focus({ preventScroll: true });
}

export function requestedDocumentType(search: string): DocumentType {
  return documentTypeSchema.safeParse(new URLSearchParams(search).get('type')).data ?? 'QUOTE';
}

export function newDocumentPath(type: DocumentType | 'ALL', customerId?: string): string {
  const query = new URLSearchParams();
  if (type !== 'ALL') query.set('type', type);
  if (customerId) query.set('customerId', customerId);
  return newWorkPath(`/documents/new?${query}`);
}
